/**
 * Holds the selectable options for Identity providers
 */
export class IdentityProviderConstants {

    /**
     * The standard - no IDP chosen
     */
    static Default: string = 'Default';
    /**
     * The identity provider for Idin/VerifyRealIdentity
     */
    static IDIN: string = 'Bluem';
    /**
     * Cleverbase AUTHENTICATION - this does not return a cleverbase Proof file
     */
    static Cleverbase_Authentication: string = 'Cleverbase_Authentication';
    /**
     * Cleverbase IDENTIFICATION - this returns a cleverbase Proof file
     */
    static Cleverbase_Identification: string = 'Cleverbase_Identification';
}